"use client";

import { useEffect } from "react";
import { Button } from "@focal/ui-kit";
import { Icon } from "@focal/ui-kit";
import { Alert, AlertDescription, AlertTitle } from "@focal/ui-kit";
import { H1 } from "@focal/ui-kit";
import { sendLog } from "@/api";
import { LogLevel } from "@/types";
import { type ErrorBoundaryProps } from "@/components/common";

export default function GlobalError({ error, reset }: ErrorBoundaryProps) {
  useEffect(() => {
    sendLog({
      level: LogLevel.ERROR,
      message: error.message,
      error: error.stack,
      component: "GlobalError",
      // Without the route we can't tell which page crashed, and the stack is
      // minified server-side — these are the only usable clues in the log.
      data: {
        name: error.name,
        route: window.location.pathname + window.location.search,
        digest: error.digest ?? "",
      },
    }).catch((error) => {
      console.error("Failed to log error", error);
    });
  }, [error]);

  return (
    <div className="flex items-center justify-center min-h-screen h-screen w-full bg-background">
      <div className="max-w-lg w-full p-6 space-y-6 self-center justify-self-center h-screen justify-center items-center flex flex-col">
        <div className="text-center space-y-4">
          <H1 spacing="none">Oops! Something went wrong</H1>
          <Alert
            variant="destructive"
            icon={<Icon name="ErrorIcon" size="sm" />}
          >
            <AlertTitle>Error</AlertTitle>
            <AlertDescription>
              An unexpected error occurred. Our team has been notified.
            </AlertDescription>
          </Alert>
          <Button
            onClick={() => {
              reset();
              // reload window
              window.location.reload();
            }}
            variant="default"
            className="w-full"
          >
            Try again
          </Button>
        </div>
      </div>
    </div>
  );
}
